import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const TriggerClawback = lazy(
  () => import('pages/triggerClawback/TriggerClawback')
);

const TriggerClawbackRoute = (
  <Route path={routeName.triggerClawback}>
    <Route
      index
      element={
        <PrivateRoute name={[PrivateRouteConst.CANCELLATION_FILE_UPLOAD]}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <TriggerClawback />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default TriggerClawbackRoute;
